import SideBar from "./SideBar";

export { InlineSideBar } from "./SideBar";

export default SideBar;
